export const metricLabels: Record<string, string> = {
  NUMBER_OF_KMS: "Number of kms",
  NUMBER_OF_TRAINSETS: "Number of trainsets",
  NUMBER_OF_COACHES_PER_TRAIN: "Coaches per train",
  NUMBER_OF_TRIPS: "Number of trips",
  NUMBER_OF_WCS_PER_COACH: "WCs per coach",
};
